var React = require('react');

function Alerta (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26.585 24.234a2.255 2.255 0 01-1.96 1.141H7.374a2.255 2.255 0 01-1.96-1.14 2.24 2.24 0 01.033-2.262L14.072 7.71A2.263 2.263 0 0116 6.625c.785 0 1.523.415 1.928 1.086l8.624 14.262a2.24 2.24 0 01.033 2.261zm-1.858-1.1L16.073 8.826a.16.16 0 00-.136-.076.16.16 0 00-.135.076L7.148 23.134a.159.159 0 00.135.24h17.31a.159.159 0 00.134-.24zM16.007 12c.693 0 1.243.448 1.243 1.137 0 .637-.022 1.226-.087 2.613-.064 1.374-.085 1.957-.085 2.579 0 .587-.524.921-1.072.921-.614 0-1.084-.321-1.084-.921 0-.622-.021-1.205-.085-2.579-.065-1.387-.087-1.976-.087-2.613 0-.694.543-1.137 1.256-1.137zm-.063 7.875c.716 0 1.306.63 1.306 1.375 0 .736-.593 1.375-1.306 1.375-.741 0-1.319-.628-1.319-1.375 0-.756.575-1.375 1.319-1.375z"}));
}

Alerta.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Alerta;

Alerta.default = Alerta;
